import { Directive, ElementRef, Input } from '@angular/core';
import { environment } from 'environments/environment';

@Directive({
	selector: '[sextant]'
})
export class SextantDirective {
	@Input('sextant') dataID: string = 'fict-sextant-id';
	@Input('url') url: string;
	
	constructor(private el: ElementRef) {
		if ( ! this.dataID) {
			throw new Error(`In SextantDirective was passed incorrect id '${this.dataID}'`);
		}
	}
	
	
	setDataID() {
		if (environment.SEXTANT) {
			if (this.url) {
				this.el.nativeElement.setAttribute('sextant-id', this.dataID + '-' + this.url);
			} else {
				this.el.nativeElement.setAttribute('sextant-id', this.dataID);
			}
		}
	}
	
	
	ngOnChanges() {
		this.setDataID();
	}
}
